import { render, staticRenderFns } from "./rekonfadb.vue?vue&type=template&id=8e8f5d06"
import script from "./rekonfadb.vue?vue&type=script&lang=js"
export * from "./rekonfadb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports